import SectionCard from "../SectionCard/SectionCard";
import { useContext, useEffect, useMemo } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import { AnimatePresence, motion } from "framer-motion";
import sortSectionList from "../../../Util/functions/ExamCreatorHelperFunctions/sortSectionList";
import addHeadersToSectionList from "../../../Util/functions/ExamCreatorHelperFunctions/addHeadersToSectionList";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";
import { examCreatorListMotionProps } from "../../../Util/animations/Animations_v2";
import filterSectionList from "../../../Util/functions/ExamCreatorHelperFunctions/filterSectionList";
import ExamListLoader from "./ExamListLoader";
import SectionHeader from "./SectionHeader";

const SectionList = ({ selectedSectionIds, handleSelectSection }) => {
  const { userData, examSections, reviewLaterSections } =
    useContext(AppContext);
  const {
    searchTerm,
    isHideCompletedChecked,
    isHideIncompleteChecked,
    selectedCategories,
    sortBy,
    isCaseListAscending,
    loadingExamList,
  } = useContext(ExamCreatorContext);

  useEffect(() => {
    document.getElementById("caseListBodyPageWrapper").scrollTo(0, 0);
  }, []);

  const filteredExamSections = useMemo(
    () =>
      filterSectionList(
        examSections,
        searchTerm,
        isHideCompletedChecked,
        isHideIncompleteChecked,
        selectedCategories
      ),
    [
      examSections,
      searchTerm,
      isHideCompletedChecked,
      isHideIncompleteChecked,
      selectedCategories,
    ]
  );
  const sortedExamSections = useMemo(
    () =>
      sortSectionList(
        filteredExamSections,
        sortBy,
        isCaseListAscending,
        reviewLaterSections
      ),
    [filteredExamSections, sortBy, isCaseListAscending, reviewLaterSections]
  );
  const examSectionsWithHeaders = useMemo(
    () =>
      addHeadersToSectionList(
        sortedExamSections,
        isCaseListAscending,
        sortBy,
        reviewLaterSections
      ),
    [sortedExamSections, isCaseListAscending, sortBy, reviewLaterSections]
  );

  return (
    <motion.div
      key="Exam List Body"
      {...examCreatorListMotionProps(userData.AnimationsDisabled, 0.997)}
    >
      <AnimatePresence mode="wait">
        {loadingExamList ? (
          <ExamListLoader />
        ) : (
          <AnimatePresence mode="wait">
            <motion.div
              className="caseListSectionWrapper"
              {...examCreatorListMotionProps(
                userData.AnimationsDisabled,
                0.997
              )}
              key="CaseListCustomSectionContainer"
            >
              {examSectionsWithHeaders.map((value, index) =>
                value.type ? (
                  <SectionHeader
                    key={`Section Header - ${value.sectionId} - ${index}`}
                    headerText={value.headerText}
                    type={value.type}
                    icon={value.icon}
                    text={value.text}
                  />
                ) : (
                  <SectionCard
                    sectionData={value}
                    handleSectionClick={handleSelectSection}
                    key={`Custom Exam Section - ${value.sectionId} - ${index}`}
                    isSectionSelected={selectedSectionIds.some(
                      (id) => id === value.sectionId
                    )}
                  />
                )
              )}
              {examSectionsWithHeaders.length === 0 && (
                <div className="caseListNoCasesContainer">
                  <h3 className="caseListCaseTitle caseListNoCasesTitle">
                    No Sections Match Your Search
                  </h3>
                  <p className="caseListCaseDiagnosisText caseListNoCasesText">
                    It looks like we don't have any sections matching your
                    search. Try expanding your search by adding categories or
                    changing your search input.
                  </p>
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default SectionList;
